import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
    hasBackground?: boolean;
}

export function LoadingSpinner({ hasBackground = true }: LoadingSpinnerProps) {
    return (
        <div
            className={`${styles.container} ${
                hasBackground ? styles.hasBackground : ''
            }`}
        >
            <div className={styles.spinner}>
                <div className={styles.dot1}></div>
                <div className={styles.dot2}></div>
                <div className={styles.dot3}></div>
            </div>
        </div>
    );
}

export default LoadingSpinner;
